var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg403(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 396.992,
    height: 147.093,
    viewBox: "0 0 396.992 147.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-540 -278.119)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(676 280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.134,174.771a58.509,58.509,0,1,0-70.691,43.007A58.508,58.508,0,0,0,187.134,174.771Zm-30.3-7.381a27.325,27.325,0,1,1-20.075-33.007A27.317,27.317,0,0,1,156.835,167.39Z",
    transform: "translate(-57.172 -89.277)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.586,129.976l-21.86-5.326-2.562,15.768,19.443,4.737Z",
    transform: "translate(-31.818 -1.175)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.744,137.543,83.053,118.319l-12.961,9.339,10.4,17.1Z",
    transform: "translate(-63.789 -26.245)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,133.523l5.326-21.86L73.559,109.1l-4.737,19.443Z",
    transform: "translate(-68.821 -62.754)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.169,125.681l19.224-11.692-9.338-12.961-17.1,10.4Z",
    transform: "translate(-48.487 -94.725)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.58,114.937l21.86,5.326L108,104.495,88.559,99.758Z",
    transform: "translate(-10.37 -99.758)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.606,112.106,103.3,131.329l12.962-9.339-10.4-17.1Z",
    transform: "translate(21.417 -79.423)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.039,114.517l-5.326,21.86,15.768,2.562,4.737-19.443Z",
    transform: "translate(29.761 -41.306)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.606,122.543,87.383,134.234,96.722,147.2l17.1-10.4Z",
    transform: "translate(4.691 -9.519)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.257,140.628,97.8,150.236l17.089-10.407-.461-19.986-17.535-9.6L79.8,120.627Zm18.587-16.553a6.341,6.341,0,1,1-7.664,4.658A6.326,6.326,0,0,1,98.844,124.075Z",
    transform: "translate(-25.357 -58.243)",
    fill: "#fd9926"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-348.939,101.356h-64.655V69.029l61.263-87.4h42.9V67.432h15.365v33.924h-15.365V125.3h-39.512Zm2.994-33.924V25.725l-27.539,41.707Z",
    transform: "translate(953.594 298.376)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.643-105.184h37.31c.391-6.642,2.93-13.869,11.33-13.869,6.446,0,10.939,3.907,10.939,12.111,0,12.111-10.353,13.283-17.776,13.088H44.8v31.06h6.837c14.455,0,20.316,4.688,20.316,14.455,0,7.618-4.493,12.893-12.111,12.893C49.688-35.446,45-41.7,45.39-51.855H8.08C8.861-17.866,30.544-3.8,61.409-3.8c30.083,0,47.664-16.995,47.664-41.608,0-18.362-9.962-28.52-23.636-33.6v-.781c8.986-2.93,21.1-12.307,21.1-31.841,0-21.878-16.409-39.264-47.273-39.264C28.786-150.894,10.619-134.681,9.643-105.184Z",
    transform: "translate(827.92 429.013)",
    fill: "#0c4767"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg403);
export default __webpack_public_path__ + "static/media/img_403.45db9963022873a7e9382b8da0579999.svg";
export { ForwardRef as ReactComponent };